import React from "react";

export default function HomeAbout() {
  return (
    <div id="home-about" className="home-about">
      <h2>Koliba "Lika"</h2>
      <p>
        Smještena u srcu Like luksuzna koliba pruža savršen prostor za potpuni
        odmor i opuštanje. Okružena mirnom prirodom, nudi utočište daleko od
        svakodnevne užurbanosti. S modernim interijerom i udobnim sadržajem,
        koliba je idealna za uživanje u privatnosti, šetnjama kroz šumu ili
        jednostavnom opuštanju. Ovdje možete doživjeti pravi mir, uživajući u
        tišini i ljepoti prirode, bez smetnji iz vanjskog svijeta.
      </p>
    </div>
  );
}
